export default {
  helpGuides: {
    title: 'Help Guides',
    location: 'meganav',
    links: [
      {
        name: 'differences-between-a-licence-and-a-lease',
        url: '/blog/differences-between-a-licence-and-a-lease',
        label: 'What are the differences between a licence and a lease?',
        imagePath: 'help-guides/lease-signing.jpg',
        uiSrefParams: { slug: 'differences-between-a-licence-and-a-lease' },
      },
      {
        name: 'things-to-consider-when-moving-office',
        url: '/blog/things-to-consider-when-moving-office',
        label: 'Things to consider when moving office',
        imagePath: 'help-guides/office-move-checklist-2.jpg',
        uiSrefParams: { slug: 'things-to-consider-when-moving-office' },
      },
      {
        name: 'how-much-office-space-do-i-need',
        url: '/blog/how-much-office-space-do-i-need',
        label: 'How much office space do I need?',
        imagePath: 'help-guides/how-much-office-space-do-i-need-2.jpg',
        uiSrefParams: { slug: 'how-much-office-space-do-i-need' },
      },
      {
        name: 'londons-best-areas-to-work-in-2018-by-industry',
        url: '/blog/londons-best-areas-to-work-in-2018-by-industry',
        label: "London's best areas to work in 2018 by industry",
        imagePath: 'help-guides/haus.jpg',
        uiSrefParams: {
          slug: 'londons-best-areas-to-work-in-2018-by-industry',
        },
      },
    ],
    more: {
      title: 'See More Help Guides',
      name: 'help-guide',
      url: '/blog/help-guide',
      label: 'See More Help Guides',
      analytics: {
        event: 'See More Help Guides Clicked',
      },
    },
    analytics: {
      event: 'Help Guides Clicked',
      data: (link) => ({
        name: link.name,
      }),
    },
  },
  learnMore: {
    title: 'Learn More',
    links: [
      {
        name: 'hot-desking',
        url: '/guides/hot-desk',
        label: 'Hot Desking',
      },
      {
        name: 'leased-offices',
        url: '/guides/leased-offices',
        label: 'Leasing',
      },
      {
        name: 'coworking',
        url: '/guides/coworking',
        label: 'Coworking',
      },
      {
        name: 'serviced-offices',
        url: '/guides/serviced-offices',
        label: 'Serviced Offices',
      },
      {
        name: 'office-space-calculator',
        url: '/guides/office-space-calculator',
        label: 'Calculate My Budget',
      },
    ],
    analytics: {
      event: 'Learn More Clicked',
      data: (link) => ({
        name: link.name,
      }),
    },
  },
  aboutHubble: {
    title: 'HubbleHQ',
    links: [
      {
        name: 'about',
        url: '/about',
        label: 'About us',
      },
      {
        name: 'blog',
        url: '/blog',
        label: 'Blog',
      },
      {
        name: 'contact',
        url: '/contact',
        label: 'Contact',
      },
    ],
    analytics: {
      event: 'About Hubble Clicked',
      data: (link) => ({
        name: link.label.replace(' ', '-').toLowerCase(),
      }),
    },
  },
};
